// extracted by mini-css-extract-plugin
var _1 = "ra-breadcrumbs";
var _2 = "ra-breadcrumbs-item";
var _3 = "ra-breadcrumbs-section";
var _4 = "ra-breadcrumbs-separator";
export { _1 as "breadcrumbsCls", _2 as "breadcrumbsItemCls", _3 as "breadcrumbsSectionCls", _4 as "breadcrumbsSeparatorCls" }
